<nb-card
  [style.width]="wider ? '500px' : '380px'"
>
  <nb-card-header>
    <span class="title">{{ title }}</span>
  </nb-card-header>
  <nb-card-body>
    <p>
      <span [innerHTML]="content"></span>
    </p>
  </nb-card-body>
  <nb-card-footer class="text-right">
    @if (canCancel) {
      <button nbButton (click)="close()" class="cancel">
        {{ 'theme.status-change-dialog.discard' | translate }}
      </button>
    }
    <button nbButton (click)="close(true)" class="ms-3">
      {{ 'theme.status-change-dialog.ok' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
